// Dữ liệu mẫu Vị trí AIS · Dự báo ETA/ETB/ETD · Dự đoán qua các lần quét của board Mint-Vessel (script PRED / ais / FC / SCAN / SST),
// chỉ cho chuyến ONE BLUE JAY 043E (tàu có hồ sơ IMO). Nguồn thật về sau: TblVesselEta · TblVesselEtaHistory.
import type { Vessel } from './types';

export interface ForecastSource {
  name: string;
  value: string;
  sub?: string;
  /** 'OK' · 'tạm dừng' · '' (không có trạng thái) */
  status: string;
  /** lệch so lịch hãng: 'đúng lịch' · '+8h' · '−2h' · '' */
  delta: string;
  at: string;
  conf: number;
  chosen: boolean;
}
export interface VesselForecast {
  port: string;
  nav: string;
  pos: string;
  sog: string;
  heading: number;
  dist: string;
  aisAt: string;
  chosen: { src: string; at: string; etb: string; etd: string; sched: string; delta: string; conf: number };
  base: string;
  sources: readonly ForecastSource[];
  /** lệch ETD (giờ) qua từng lần quét */
  scans: readonly number[];
  scanFrom: string;
  scanTo: string;
}

const FORECAST: VesselForecast = {
  port: 'Cái Mép · VNVUT',
  nav: 'Đang neo',
  pos: '10°19′N 107°02′E',
  sog: '0,5 kn · 312°',
  heading: 312,
  dist: 'Cách Cái Mép 14 hải lý',
  aisAt: '13:52',
  chosen: { src: 'AIS · HiFleet', at: '13:52', etb: '23/Oct/2026 10:00', etd: '24/Oct/2026 02:00', sched: 'lịch 23/Oct 18:00', delta: '+8h', conf: 82 },
  base: '23/Oct 18:00',
  sources: [
    { name: 'AIS · HiFleet', value: 'ETB 23/Oct 10:00 · ETD 24/Oct 02:00', sub: 'AIS khai ETA 23/Oct 08:00 · đích VNVUT', status: 'OK', delta: '+8h', at: '13:52', conf: 82, chosen: true },
    { name: 'ePort · SNP', value: 'ETB 23/Oct 12:00 · ETD 24/Oct 04:00', status: 'OK', delta: '+10h', at: '13:40', conf: 0, chosen: false },
    { name: 'ePort · VICT', value: '—', sub: 'Không có chuyến này', status: 'OK', delta: '—', at: '13:40', conf: 0, chosen: false },
    { name: 'Cảng vụ TP.HCM', value: 'ETA 22/Oct 20:00', sub: 'Bản tin 21/Oct', status: 'tạm dừng', delta: '—', at: '21/Oct 09:00', conf: 0, chosen: false },
    { name: 'Hãng tàu · ONE API', value: 'ETD 23/Oct 18:00', status: 'OK', delta: 'đúng lịch', at: '12:05', conf: 60, chosen: false },
    { name: 'Kế hoạch', value: 'ETD 23/Oct 18:00', status: '', delta: 'đúng lịch', at: '', conf: 40, chosen: false },
    { name: 'Lịch cảng', value: '—', status: '', delta: '—', at: '', conf: 0, chosen: false },
    { name: 'Maersk API', value: '—', status: 'chưa bật', delta: '—', at: '', conf: 0, chosen: false },
  ],
  scans: [0, 0, 0, 2, 2, 3, 4, 6, 6, 7, 8, 8],
  scanFrom: '21/Oct 00:00',
  scanTo: '22/Oct 13:52',
};

export const forecastOf = (v: Vessel): VesselForecast | null => (v.id === 'ONE BLUE JAY|043E' ? FORECAST : null);
